export const SIZE_QR_PC = 220;
